import { createNotImplementedMethod } from '../utils';
var NotImplementedCustomerRepository = /** @class */ (function () {
    function NotImplementedCustomerRepository() {
        this.getCustomer = createNotImplementedMethod();
        this.updateCustomer = createNotImplementedMethod();
        this.checkCustomerServer = createNotImplementedMethod();
    }
    return NotImplementedCustomerRepository;
}());
export { NotImplementedCustomerRepository };
